import React from 'react';

const FiltersField = ({ children }: React.PropsWithChildren) => {
    return <div className="border-border flex flex-col gap-2.5 rounded-lg border bg-white p-2.5">{children}</div>;
};

export default FiltersField;
